import { Typography } from "@mui/material";

export default function CopyrightText(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'ActaBlue © '}
      {new Date().getFullYear()}
    </Typography>
  );
}